export default __webpack_public_path__ + "static/whatIsDesc-94bd11e495b970478a108d9c76e16aeb.png";